import axios from '@/libs/api.request'
import url from '@/config/url'
import axiosRequest from '@/libs/axios'
import Axiosp from 'axios'
let db = {
    install(Vue){
        let db = this
        Vue.mixin({
            created: function () {
                this.$db = db
            }
        })
        this.config = url
    }
}
    /**
     * 所有获取单个信息的方法
     * @param {} url 
     */
    db.get = function(url,params={}){
        return axios.request({
            url:url,
            params,
            method:'get'
        })

    }
    
       
        /**
     * 删除单个信息的方法
     * @param {} url 
     */
    db.delete = function(url,params={}){
        return axios.request({
            url:url,
            params,
            method:'delete'
        })
    }
    

/**
 * params 为 对象
 * 通用的获取列表
 */
db.list = function(url,params){
    let data = {
        
    }
    Object.assign(data, params);
    return axios.request({
        url:url,
        data,
        method:'post'
    })
}
/**
 * 通用的获取单对象信息
 */
// db.details = function(url,params){
//     let data = {
//         app_type:app_type,
//     }
//     Object.assign(data, params);
//     return axios.request({
//         url:url,
//         data,
//         method:'post'
//     })
// }

/**
 * 通用的post数据提交
 */
db.post = function (url,params){
    let data = {}
   
    Object.assign(data, params);
    return axios.request({
        url:url,
        data,
        method:'post'
    })
}
//文件下载
db.downFilePost = function(url,params){
   
    return Axiosp.request({
        url:url,
        params:params,
        method:'get',
        responseType: 'arraybuffer'
    })
}

// 获取省市县
db.getDistrict = function (province_id=false,city_id=false,county_id=false){
    let district = ""
    if( province_id ){
       return new Promise((resolve,reject) =>{
            axiosRequest.get('/static/district/province.json').then(response => {
                response.data.forEach((item,index)=>{
                    if( item.id == province_id ){
                        district = item.fullname
                        resolve(district)
                        return false
                    }
                })
            })
        }).then( res => {
          
          if( city_id ) {
              
                return new Promise((resolve,reject)=>{
                  if( city_id != "" )
                   axiosRequest.get('/static/district/city.json').then(response => {
                       response.data[province_id].forEach((city,cindex)=>{
                            if( city.id == city_id ){
                                district = res+" "+city.fullname
                                resolve(district)
                                return false
                            }
                       }) 
                   }) 
                }).then(res=>{
                  if( county_id  ) {
                    return new Promise((resolve,reject)=>{
                        axiosRequest.get('/static/district/county.json').then(response => {
                            response.data[city_id].forEach((county,ctindex)=>{
                                if( county.id == county_id ){
                                    district = res+" "+county.fullname
                                    resolve(district)
                                }
                            })
                        }).catch(err=>{
                            console.log(err)
                        })
                    })
                  } else {
                    return Promise.resolve(district)
                  }
                }).catch(err=>{
                    console.log(err)
                })
            } else {
    
              return Promise.resolve(district)
            }
              
          }).catch(err=>{
            console.log(err)
        })
  }else{
    return district;
  }
 
}
 /** 
    * 新增 删除 图片啊
    * @param Array fileList 上传成功或者删除成功的回调
    * @param String name 需要提交的对象中的哪个数组名字
    * @param Object objName 需要提交的哪个对象
    * @param Boolean remove 是否是删除
    */
   db.updatePicArr =  function(fileList,name,objName,remove=false){ 
    if(remove){
        let arr = []
        fileList.forEach(item=>{
            arr.push(item.response.data.id)
        })
        objName[name] = arr;
    } else {
        let  index1 = fileList.length - 1;  // 记录数组位置
        if(objName[name].length > 0){
            objName[name].some((item,index)=>{
                if(objName[name][index] == fileList[index1].response.data.id){
                    fileList = fileList.pop(); // 删除最后一个元素
                    this.$message.error('请不要上传相同文件')
                    return true  // 终止循环
                }
            })
            if(fileList[index1]){
                objName[name].push(fileList[index1].response.data.id)
            }
        } else {
            objName[name].push(fileList[index1].response.data.id)
        }
    }
    
}

export default db;


// WEBPACK FOOTER //
// ./src/api/db.js